<template>
  <SettingsContainerDiv type="inner" :isSession="true">
    <div class="reset-colors" @click="resetColors">Reset to defaults</div>
    <SettingArea
      :title="transparentColor.title"
      :isSession="true"
      :description="transparentColor.description"
      :isColor="true"
      :colors="transparentColor.colors"
      :currentSelection="transparentColor.current"
      @setColor="updatePreference('transparentColor', $event)"
    >
    </SettingArea>
    <SettingArea
      :title="backgroundColor.title"
      :isSession="true"
      :description="backgroundColor.description"
      :isColor="true"
      :colors="backgroundColor.colors"
      :currentSelection="backgroundColor.current"
      @setColor="updatePreference('backgroundColor', $event)"
    >
    </SettingArea>
    <!-- <SettingArea
      :title="textColor.title"
      :isSession="true"
      :description="textColor.description"
      :isColor="true"
      :colors="textColor.colors"
      :currentSelection="textColor.current"
      @setColor="updatePreference('textColor', $event)"
    >
    </SettingArea> -->
  </SettingsContainerDiv>
</template>

<script>
import { mapState } from "vuex";
import SettingArea from "../../../../BookingPages/Settings/BaseComponents/SettingArea";
import SettingsContainerDiv from "../../../../BookingPages/Settings/BaseComponents/SettingsContainerDiv";

export default {
  name: "SettingsDesign",
  data() {
    return {
      transparentColor: {
        title: "Bottom layer color",
        description: "Customize the lower layer color of session elements.",
        colors: [
          "#f1e4f7",
          "#e4edf7",
          "#e4ebf7",
          "#e4f5f7",
          "#e8f7e4",
          "#f6f7e4",
          "#f7efe4",
          "#f7eae4",
        ],
        current: null,
      },
      backgroundColor: {
        title: "Surface layer color",
        description: "Customize the surface color of session elements.",
        colors: [
          "#f1e4f7",
          "#e4edf7",
          "#e4ebf7",
          "#e4f5f7",
          "#e8f7e4",
          "#f6f7e4",
          "#f7efe4",
          "#f7eae4",
        ],
        current: null,
      },
      // textColor: {
      //   title: "Text color",
      //   description: "Change the color of texts in the session.",
      //   colors: [
      //     "#f1e4f7",
      //     "#e4edf7",
      //     "#e4ebf7",
      //     "#e4f5f7",
      //     "#e8f7e4",
      //     "#f6f7e4",
      //     "#f7efe4",
      //     "#f7eae4",
      //   ],
      //   current: null,
      // },
    };
  },
  components: {
    SettingArea,
    SettingsContainerDiv,
  },
  computed: {
    ...mapState({
      sessionPreferences: (state) => state.room.sessionPreferences,
    }),
  },
  mounted() {
    this.setCurrentDesignSettings();
  },
  methods: {
    setCurrentDesignSettings() {
      const preferences = this.sessionPreferences;

      this.backgroundColor.current = preferences.backgroundColor || "#fff";
      this.transparentColor.current =
        preferences.transparentColor || "#ffffffa6";
      // this.textColor.current = preferences.textColor || "#111";
    },
    async updatePreference(preference, newValue) {
      if (!preference || !newValue) {
        return console.warn("missing preference type or newValue");
      }
      console.log("preference, value", preference, newValue);

      /* 1. Update Vuex preferences */
      const updateData = { field: preference, newValue };
      await this.$store.dispatch("room/updatePreferenceField", updateData);

      /* 2. Update current in passed options */
      this[preference].current = newValue;
    },
    async resetColors() {
      await this.updatePreference("backgroundColor", "#fff");
      await this.updatePreference("transparentColor", "#ffffffa6");
      // await this.updatePreference("textColor", "#111");
    },
  },
};
</script>